import { render, staticRenderFns } from "./downguid.vue?vue&type=template&id=b8734e8a&scoped=true"
import script from "./downguid.vue?vue&type=script&lang=js"
export * from "./downguid.vue?vue&type=script&lang=js"
import style0 from "./downguid.vue?vue&type=style&index=0&id=b8734e8a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8734e8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8734e8a')) {
      api.createRecord('b8734e8a', component.options)
    } else {
      api.reload('b8734e8a', component.options)
    }
    module.hot.accept("./downguid.vue?vue&type=template&id=b8734e8a&scoped=true", function () {
      api.rerender('b8734e8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/downguid.vue"
export default component.exports